// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2dbm4","title":"AfterFrontImage_title__2ib0O"};